import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

import List from "./components/List";
import Breadcrumb from "./components/Breadcrumb";

const Immigration = (props: any) => {
  const { t } = useTranslation();
  document.title = `${t("Immigration")} - ${t("List View")} | ${process.env.REACT_APP_NAME}`;

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "#",
      label: t("Immigration"),
      active: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        <Breadcrumb breadcrumbItems={breadcrumbItems} />

          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <List />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Immigration;
